import Button from "/src/components/UI/Button/Button";
import { DIMENSIONS, RATING_BANDS } from "../../data/scorecard";
import { ScoreRing, useTwoStepConfirm } from "../shared";

const TIME_FORMAT = { hour: "2-digit", minute: "2-digit", second: "2-digit" };

function LiveScorePanel({ totals, flagsRaised, missing, savedAt, onSubmit, onClear, onOpenGuide }) {
    const { total, scoredCount, band, biggestLosses } = totals;
    const [confirmClear, handleClear] = useTwoStepConfirm(onClear);

    const canSubmit = missing.length === 0;

    return (
        <aside className="ce-live">
            <div className="ce-live__card">
                <div className="ce-live__head">
                    <span>Live score</span>
                    <button type="button" className="ce-link" onClick={onOpenGuide}>
                        <i className="fas fa-book-open"></i> Manager guide
                    </button>
                </div>

                <ScoreRing value={total} color={band ? band.color : "var(--gray)"} size={176}>
                    <strong className="ce-ring__number">{scoredCount ? Math.round(total * 100) : "—"}{scoredCount ? <small>%</small> : null}</strong>
                    <span className="ce-ring__band" style={{ color: band ? band.color : "var(--gray)" }}>
                        {band ? band.label : "Not scored yet"}
                    </span>
                </ScoreRing>

                <div className="ce-live__scale" aria-label="Rating bands">
                    {[...RATING_BANDS].reverse().map((item) => (
                        <span key={item.key} className={"ce-live__step" + (band?.key === item.key ? " is-current" : "")} style={{ "--step-color": item.color }}>
                            <i></i>
                            <b>{item.min ? `${Math.round(item.min * 100)}%+` : "<55%"}</b>
                            {item.label}
                        </span>
                    ))}
                </div>

                <div className="ce-live__progress">
                    <div className="ce-bar"><span className="s2" style={{ width: `${(scoredCount / DIMENSIONS.length) * 100}%` }} /></div>
                    <span>{scoredCount}/{DIMENSIONS.length} dimensions scored</span>
                </div>

                {biggestLosses.length > 0 && (
                    <div className="ce-live__losses">
                        <h5>Where points are lost</h5>
                        {biggestLosses.map(({ dimension, points }) => (
                            <div key={dimension.id} className="ce-live__loss">
                                <span>{dimension.name}</span>
                                <b>−{(points * 100).toFixed(1)}</b>
                            </div>
                        ))}
                    </div>
                )}

                <div className="ce-live__meta">
                    <span className={"ce-chip" + (flagsRaised ? " ce-chip--pink" : "")}><i className="fas fa-flag"></i> {flagsRaised} flagged</span>
                </div>

                <Button
                    className="validate"
                    disabled={!canSubmit}
                    onClick={onSubmit}
                    label={<><i className="fas fa-paper-plane"></i>Submit evaluation</>}
                />
                {!canSubmit && <p className="ce-live__missing">Still needed: {missing.join(" · ")}</p>}

                <Button
                    className="cancel"
                    onClick={handleClear}
                    label={<><i className="fas fa-undo"></i>{confirmClear ? "Click again to clear everything" : "Clear form"}</>}
                />

                <p className="ce-live__saved">
                    <i className="fas fa-check-circle"></i>{" "}
                    {savedAt ? `Draft saved at ${savedAt.toLocaleTimeString([], TIME_FORMAT)}` : "Draft autosaves as you type"}
                </p>
            </div>
        </aside>
    );
}

export default LiveScorePanel;
